/**
 * _address_match.js — when Chip AI may choose an address suggestion for the user.
 *
 * Chip AI form fill writes the address it heard, then searches it. It picks a
 * suggestion only when the user's words match exactly ONE of them: every word
 * they said (house number, street, suburb, postcode) appears in that
 * suggestion and in no other. Anything less is a guess, and a guessed address
 * puts a pin in the wrong place without anyone noticing, so the list is shown
 * instead. "12 Smith Road" with no suburb matches a Smith Road in several
 * suburbs and is shown; "12 Smith Road Penrith" is picked.
 *
 * An address with no number in it is never picked: a bare street or suburb is
 * not a place to send someone.
 *
 * Street types are compared in their short form, so "Road" said matches "Rd"
 * in the suggestion and the other way round.
 *
 * Imported by chip_fill_controller.js. Tested by tests/js/address_match.test.mjs.
 */

const STREET_TYPES = {
    road: "rd", street: "st", avenue: "ave", av: "ave", drive: "dr",
    court: "ct", place: "pl", crescent: "cres", cr: "cres", parade: "pde",
    highway: "hwy", lane: "ln", terrace: "tce", close: "cl", boulevard: "blvd",
    circuit: "cct", esplanade: "esp", grove: "gr", square: "sq",
};

/** The one suggestion the words clearly mean, or null. */
export function confidentMatch(query, suggestions) {
    const wanted = words(query);
    if (!wanted.some((word) => /\d/.test(word))) return null;
    const matches = (suggestions || []).filter((suggestion) => {
        const found = new Set(words(suggestion.display_name));
        return wanted.every((word) => found.has(word));
    });
    return matches.length === 1 ? matches[0] : null;
}

function words(text) {
    return (text || "")
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter(Boolean)
        .map((word) => STREET_TYPES[word] || word);
}
